<script>
export default {
  name: 'modalVS',
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
<template>
  <transition name="modal-fade">
    <div class="modal-backdropVS">
      <div class="modalVS"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-headerVS"
          id="modalTitle"
        >
          <slot name="header">
           <div class="page-titleVS" id="ph-title"><h2>Vida Software</h2></div>

            <button
              class="btn-closeVS"
              @click="close"
              aria-label="Close modal"
            >
              x
            </button>
          </slot>
        </header>
        <section
          class="modal-bodyVS"
          id="modalDescription"
        >
          <slot name="body">
            <div class="page-bodyVS">
              <p class="texto-interiorVS">+51 1 60 78350</p>
              <p  class="texto-interiorVS">informes@vida.software</p>
              <p  class="texto-interiorVS">Calle Monte Rosa 240, Oficina 801</p>
              <p  class="texto-interiorVS">Edificio empresarial Tribeca</p>
              <p class="texto-interiorVS">Santiago de Surco</p>
            </div>
          </slot>
        </section>
        <!--<footer class="modal-footer">
          <slot name="footer">
            I'm the default footer!

            <button
              type="button"
              class="btn-green"
              @click="close"
              aria-label="Close modal"
            >
              Close me!
            </button>
          </slot>
        </footer>-->
      </div>
    </div>
  </transition>
</template>
<style scoped>
@import '../assets/modalvidasoftwarestyle.css';
</style>
